import { View } from "@react-pdf/renderer";
import { ResumePDFText, ResumePDFHighlightableText } from "components/Resume/ResumePDF/common";
import { TemplateFourResumeSection } from "./common";
import { styles, spacing } from "components/Resume/ResumePDF/styles";

export const Summary = ({
  heading,
  summary,
  themeColor,
  enableHighlight = false,
  enableMistakeHighlight = false,
}: {
  heading: string;
  summary: string;
  themeColor: string;
  enableHighlight?: boolean;
  enableMistakeHighlight?: boolean;
}) => {
  return (
    <TemplateFourResumeSection themeColor={themeColor} heading={heading}>
      <View wrap={false}>{summary && ((enableHighlight || enableMistakeHighlight) ? (
        <ResumePDFHighlightableText
          text={summary}
          section="profile"
          itemIndex={null}
          enableMistakeHighlight={enableMistakeHighlight}
        />
      ) : (
        <ResumePDFText>{summary}</ResumePDFText>
      ))}</View>
    </TemplateFourResumeSection>
  );
};
